// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCommunityMetricsSeries {
    'steps_start_times': Array<number>;
    'drops_created': Array<number>;
    'distinct_droppers': Array<number>;
    'main_stage_submissions': Array<number>;
    'main_stage_distinct_voters': Array<number>;
    'main_stage_votes': Array<number>;
    'network_tdh': Array<number>;
    'tdh_on_main_stage_submissions': Array<number>;
    'consolidations_formed': Array<number>;
    'xtdh_granted': Array<number>;
    'active_identities': Array<number>;
    'profile_count': Array<number>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "steps_start_times",
            "baseName": "steps_start_times",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "drops_created",
            "baseName": "drops_created",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "distinct_droppers",
            "baseName": "distinct_droppers",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "main_stage_submissions",
            "baseName": "main_stage_submissions",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "main_stage_distinct_voters",
            "baseName": "main_stage_distinct_voters",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "main_stage_votes",
            "baseName": "main_stage_votes",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "network_tdh",
            "baseName": "network_tdh",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "tdh_on_main_stage_submissions",
            "baseName": "tdh_on_main_stage_submissions",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "consolidations_formed",
            "baseName": "consolidations_formed",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "xtdh_granted",
            "baseName": "xtdh_granted",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "active_identities",
            "baseName": "active_identities",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "profile_count",
            "baseName": "profile_count",
            "type": "Array<number>",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiCommunityMetricsSeries.attributeTypeMap;
    }

    public constructor() {
    }
}
